import http from '../../http/base';
import { API_PATHS } from '../../http/configs';

export default {
    getMe: () => http.get(API_PATHS.me)
};